import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useClientId } from "@/features/clients/detail/use-client-id";
import { CreditNotesPage } from "@/features/credit-notes/credit-notes-page";

export function ClientCreditNotesPage() {
  const clientId = useClientId();
  return (
    <div className="space-y-3">
      <div className="flex justify-end">
        <Button asChild size="sm">
          <Link to="/credit-notes/new" search={{ client: clientId }}>
            <Plus />
            New credit note
          </Link>
        </Button>
      </div>
      <CreditNotesPage clientId={clientId} embedded />
    </div>
  );
}
